import {Subscription} from 'rxjs';

import IPlayer                   from '../../../Player/Interfaces/IPlayer';
import createPlayRejectionStream from '../../../Solutions/Shared/Streams/createPlayRejectionStream';

import createDeactivateSliderStream   from './Streams/createDeactivateSliderStream';
import createLocalStorageVolumeStream from './Streams/createLocalStorageVolumeStream';
import createVolumeChangeStream       from './Streams/createVolumeChangeStream';
import createVolumeSliderDragStream   from './Streams/createVolumeSliderDragStream';
import createVolumeSliderTapStream    from './Streams/createVolumeSliderTapStream';
import createVolumeTapStream          from './Streams/createVolumeTapStream';
import subscribeToConsumerVolume      from './Subscribers/subscribeToConsumerVolume';
import subscribeToDeactivateSlider    from './Subscribers/subscribeToDeactivateSlider';
import subscribeToLocalStorageVolume  from './Subscribers/subscribeToLocalStorageVolume';
import subscribeToPlayRejection       from './Subscribers/subscribeToPlayRejection';
import subscribeToVolumeChange        from './Subscribers/subscribeToVolumeChange';
import subscribeToVolumeSliderDrag    from './Subscribers/subscribeToVolumeSliderDrag';
import subscribeToVolumeSliderTap     from './Subscribers/subscribeToVolumeSliderTap';
import subscribeToVolumeTap           from './Subscribers/subscribeToVolumeTap';

const connectVolumeSubscriptions = (
    player: IPlayer
): Subscription[] => {
    const {localStorage, volume} = player.state.stores;
    const {uiEvents$} = player.ui;
    const {mediaEvents$} = player.solution;

    return [
        subscribeToLocalStorageVolume(createLocalStorageVolumeStream(localStorage.update$), volume),
        subscribeToDeactivateSlider(createDeactivateSliderStream(uiEvents$), volume),
        subscribeToVolumeChange(createVolumeChangeStream(mediaEvents$, volume.update$), volume),
        subscribeToVolumeSliderDrag(createVolumeSliderDragStream(uiEvents$), volume),
        subscribeToVolumeSliderTap(createVolumeSliderTapStream(uiEvents$), volume),
        subscribeToVolumeTap(createVolumeTapStream(uiEvents$), volume),
        subscribeToConsumerVolume(player.consumerInput.volume$, volume),
        subscribeToPlayRejection(createPlayRejectionStream(mediaEvents$), volume)
    ];
};

export default connectVolumeSubscriptions;